import React from 'react';

interface ModernCardProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  children: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
  headerClassName?: string;
}

/**
 * Premium Card Wrapper with Hover Glow & Subtle Elevation
 */
const ModernCard = ({
  title,
  subtitle,
  children,
  action,
  className = '',
  headerClassName = '',
}: ModernCardProps) => (
  <div
    className={`bg-white rounded-2xl border border-slate-200/80 shadow-sm hover:shadow-md hover:border-slate-300 transition-all duration-200 overflow-hidden ${className}`}
  >
    {title && (
      <div
        className={`px-4 py-3 border-b border-slate-100 flex items-center justify-between bg-slate-50/50 ${headerClassName}`}
      >
        <div>
          {typeof title === 'string' ? (
            <h3 className="text-base font-semibold text-slate-800 tracking-tight">
              {title}
            </h3>
          ) : (
            title
          )}
          {subtitle && (
            <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>
          )}
        </div>
        {action && <div>{action}</div>}
      </div>
    )}
    <div className="p-4">{children}</div>
  </div>
);

export default ModernCard;
